module.exports = __webpack_public_path__ + "img/ys.9030e770.png";